import { Provider } from "~/application/types/entities/Provider.type";
import { ProviderDTO } from "../dtos/ProviderDTO";

export const mapProviderDTO = (data: ProviderDTO): Provider => {
  return {
    uuid: data.uuid,
    name: data.name,
    slug: data.slug,
    logo: data.logo,
    active: Boolean(data.active),
    avatarUrl: data.avatar_url,
    isOffline: data.is_offline,
    integrationCode: data.integration_code,
    serviceType: data.service_type,
    services: data?.services?.map((service) => ({
      uuid: service.uuid,
      serviceType: service.service_type,
    })),
  };
};
